import React from "react";
import moment from "moment-timezone";
import DescriptionIcon from "@mui/icons-material/Description";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CloseIcon from "@mui/icons-material/Close";
import OpacityIcon from "@mui/icons-material/Opacity";
import InfoIcon from "@mui/icons-material/Info";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
import Filter3Icon from "@mui/icons-material/Filter3";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import GppBadIcon from "@mui/icons-material/GppBad";
import AddTaskIcon from "@mui/icons-material/AddTask";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import WarningIcon from "@mui/icons-material/Warning";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import GavelIcon from "@mui/icons-material/Gavel";
import SummarizeIcon from "@mui/icons-material/Summarize";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AddAlertIcon from "@mui/icons-material/AddAlert";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import LockIcon from "@mui/icons-material/Lock";
import ApiIcon from "@mui/icons-material/Api";
import ArtTrackIcon from "@mui/icons-material/ArtTrack";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import BadgeIcon from "@mui/icons-material/Badge";
import BlindsClosedIcon from "@mui/icons-material/BlindsClosed";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";
import SpaIcon from "@mui/icons-material/Spa";
import SecurityIcon from "@mui/icons-material/Security";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import DialpadIcon from "@mui/icons-material/Dialpad";
import ArticleIcon from "@mui/icons-material/Article";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";

// ---------------------------------------------------------------------------
// Paleta (spójna z DetailPage: #1976d2 / #0d47a1, karty #fff + #e0e0e0)
// ---------------------------------------------------------------------------

export const COLORS = {
  primary: "#1976d2",
  primaryDark: "#0d47a1",
  primarySoft: "#e3f2fd",
  border: "#e0e0e0",
  borderSoft: "#f0f0f0",
  textMuted: "#666",
  danger: "#d32f2f",
  success: "#2e7d32",
  warning: "#f57c00",
};

const TONE_COLORS = {
  default: "#424242",
  red: "#d32f2f",
  blue: "#1976d2",
  green: "#2e7d32",
};

// ---------------------------------------------------------------------------
// Opcje list rozwijanych
// ---------------------------------------------------------------------------

export const STATUS_OPTIONS = [
  "Do przygotowania",
  "Wstępnie przygotowane",
  "Przygotowane",
  "Do weryfikacji",
  "Do wysłania",
  "Wysłane",
  "Unieważnione przez OC",
  "Odprawa zakończona",
  "Zrealizowane",
  "Anulowane",
];

export const RODZAJ_OPTIONS = [
  "Import",
  "Eksport",
  "Tranzyt",
  "Wyprowadzenie ze składu",
  "Wprowadzenie na skład",
  "Uszlachetnianie czynne",
  "Uszlachetnianie bierne",
  "Powrotny przywóz",
  "Powrotny wywóz",
  "Eksport - wpis do rejestru",
  "Import - wpis do rejestru",
  "Eksport PL i import inny kraj",
];

export const TRANSPORT_OPTIONS = [
  "Na Kołach",
  "Kurier MU MAN zakład",
  "Kurier MU VOLKSWAGEN MOTOR POLSKA",
  "Kurier",
  "W drodze",
  "Magazyn Warszawa",
  "Zakończono",
];

export const DOKUMENTY_OPTIONS = ["Tak", "Nie"];

// Statusy objęte presetem "Moje odprawy" (jak w poprzedniej wersji dashboardu).
const MY_STATUSES = [
  "Do przygotowania",
  "Wstępnie przygotowane",
  "Wysłane",
  "Odprawa zakończona",
  "Do wysłania",
  "Do weryfikacji",
];
const MY_TRANSPORTS = ["Kurier", "Na Kołach", "W drodze", "Kurier MU MAN zakład"];

// ---------------------------------------------------------------------------
// Wygląd statusów i rodzajów transportu
// ---------------------------------------------------------------------------

const STATUS_TONES = {
  "Do przygotowania": { bg: "#fff3e0", fg: "#e65100" },
  "Wstępnie przygotowane": { bg: "#fff8e1", fg: "#b26a00" },
  Przygotowane: { bg: "#e8f5e9", fg: "#2e7d32" },
  "Do weryfikacji": { bg: "#f3e5f5", fg: "#7b1fa2" },
  "Do wysłania": { bg: "#e3f2fd", fg: "#1565c0" },
  Wysłane: { bg: "#e0f2f1", fg: "#00695c" },
  "Do poprawy": { bg: "#fff3e0", fg: "#bf360c" },
  "Przyjęte przez Gwaranta": { bg: "#e8eaf6", fg: "#283593" },
  "Wysłano do urzędu": { bg: "#e1f5fe", fg: "#01579b" },
  "Zwolniono do tranzytu": { bg: "#f1f8e9", fg: "#33691e" },
  "Tranzyt zakończony": { bg: "#e8f5e9", fg: "#1b5e20" },
  "Odprawa zakończona": { bg: "#e8f5e9", fg: "#1b5e20" },
  "Unieważnione przez OC": { bg: "#ffebee", fg: "#b71c1c" },
  Zrealizowane: { bg: "#eeeeee", fg: "#424242" },
  Anulowane: { bg: "#eeeeee", fg: "#757575" },
};

export const getStatusTone = (status) =>
  STATUS_TONES[status] || { bg: "#f5f5f5", fg: "#424242" };

// Kolory "lampek" transportu - te same znaczenia co w poprzedniej wersji (opis w legendzie).
// Pojedynczy kolor albo [lewa, prawa] dla lampek dwukolorowych.
export const TRANSPORT_LEDS = {
  "Na Kołach": { color: "#e53935", label: "Na kołach" },
  Kurier: { color: "#fdd835", label: "Kurier" },
  "Kurier MU MAN zakład": {
    color: ["#e53935", "#fdd835"],
    label: "Kurier MU MAN zakład",
  },
  "Kurier MU VOLKSWAGEN MOTOR POLSKA": {
    color: ["#e53935", "#fdd835"],
    label: "Kurier MU VW Motor Polska",
  },
  "Magazyn Warszawa": { color: "#3498db", label: "Magazyn Warszawa" },
  "W drodze": { color: "#9e9e9e", label: "W drodze" },
  Zakończono: { color: "#ffffff", label: "Zakończono", outlined: true },
};

export const getTransportLed = (transport) =>
  TRANSPORT_LEDS[transport] || {
    color: "#bdbdbd",
    label: transport || "—",
    outlined: true,
  };

// ---------------------------------------------------------------------------
// Znaczniki (ikony w wierszu + checkboxy w filtrach)
// ---------------------------------------------------------------------------

const TextBadge = ({ text, className, style }) => (
  <span
    className={className}
    style={{ fontWeight: 800, fontSize: 13, lineHeight: "18px", ...style }}
  >
    {text}
  </span>
);
const CeIcon = (props) => <TextBadge text="CE" {...props} />;
const CombinedIcon = (props) => (
  <TextBadge text="&" style={{ fontSize: 17 }} {...props} />
);

export const MARKER_GROUPS = [
  { id: "braki", title: "Braki w odprawie celnej" },
  { id: "plik", title: "Przygotowany plik do zaczytania" },
  { id: "ograniczenia", title: "Towary podlegające dodatkowym ograniczeniom" },
  { id: "uwagi", title: "Uwagi" },
  { id: "finanse", title: "Uwagi do działu finansowego" },
];

// field - kolumna w wierszu, filterKey - klucz znacznika w filtrach backendu (brak = tylko ikona),
// when - opcjonalny predykat zamiast `field === 1`.
// Kolejność = kolejność ikon w wierszu.
export const MARKERS = [
  { field: "KWBox", filterKey: "KW", label: "Kontrola wewnętrzna", Icon: Brightness7Icon, tone: "default", group: "uwagi" },
  { field: "brakCertyfikatyBox", filterKey: "brakCertyfikaty", label: "Certyfikaty", Icon: SecurityIcon, tone: "default", group: "braki" },
  { field: "DSKBox", filterKey: "DSK", label: "DSK", Icon: ArticleIcon, tone: "default", group: "braki" },
  { field: "onwoz", label: "Oczekiwanie na wykonanie obciążenia zabezpieczenia", Icon: HourglassBottomIcon, tone: "default" },
  {
    field: "brakInne",
    label: "Inny brak w odprawie",
    Icon: HelpOutlineIcon,
    tone: "default",
    when: (row) => typeof row.brakInne === "string" && row.brakInne.trim() !== "",
  },
  { field: "brakEksportZKrajuWywozuBox", filterKey: "brakEksportZKrajuWywozu", label: "Eksport z kraju wywozu", Icon: UpgradeIcon, tone: "default", group: "braki" },
  { field: "brakExcelBox", filterKey: "brakExcel", label: "Plik Excel z danymi", Icon: DialpadIcon, tone: "default", group: "braki" },
  { field: "fakturaBox", filterKey: "faktura", label: "Faktura", Icon: DescriptionIcon, tone: "default", group: "braki" },
  { field: "listPrzewozowyBox", filterKey: "listPrzewozowy", label: "List przewozowy", Icon: MailOutlineIcon, tone: "default", group: "braki" },
  { field: "kosztyTransportuBox", filterKey: "kosztyTransportu", label: "Koszty transportu", Icon: MonetizationOnIcon, tone: "default", group: "braki" },
  { field: "informacjeOTowarzeBox", filterKey: "informacjeOTowarze", label: "Informacje o towarze", Icon: InfoIcon, tone: "default", group: "braki" },
  { field: "T1Box", filterKey: "T1", label: "T1", Icon: TextFieldsIcon, tone: "default", group: "braki" },
  { field: "swiadectwoBox", filterKey: "swiadectwo", label: "Świadectwo", Icon: AssignmentTurnedInIcon, tone: "default", group: "braki" },
  { field: "plikiBox", filterKey: "pliki", label: "Plik do zaczytania", Icon: InsertDriveFileIcon, tone: "green", group: "plik" },
  { field: "brakUpowaznieniaBox", filterKey: "brakUpowaznienia", label: "Upoważnienie", Icon: AddTaskIcon, tone: "default", group: "braki" },
  { field: "eoriBox", filterKey: "eori", label: "EORI", Icon: AssignmentIndIcon, tone: "default", group: "braki" },
  { field: "sankcjeBox", filterKey: "sankcje", label: "Sankcje", Icon: CloseIcon, tone: "red", group: "ograniczenia" },
  { field: "CBAMBox", filterKey: "CBAM", label: "CBAM", Icon: OpacityIcon, tone: "red", group: "ograniczenia" },
  { field: "CEBox", filterKey: "CE", label: "CE", Icon: CeIcon, tone: "red", group: "ograniczenia" },
  { field: "odprawaLaczonaBox", label: "Odprawa łączona", Icon: CombinedIcon, tone: "red" },
  { field: "kilkaRazyBox", filterKey: "kilkaRazy", label: "Odprawa wysłana kilka razy ze względu na błąd klienta", Icon: ContactEmergencyIcon, tone: "blue", group: "finanse" },
  { field: "ATRBox", filterKey: "ATR", label: "A. TR", Icon: AddAlertIcon, tone: "blue", group: "finanse" },
  { field: "EURBox", filterKey: "EUR", label: "EUR. 1", Icon: AirportShuttleIcon, tone: "blue", group: "finanse" },
  { field: "RPSBox", filterKey: "RPS", label: "RPS", Icon: ApiIcon, tone: "blue", group: "finanse" },
  { field: "probZab", label: "Problem z zabezpieczeniem", Icon: LockIcon, tone: "blue" },
  { field: "WIJHARSBox", filterKey: "WIJHARS", label: "WIJHARS", Icon: ArtTrackIcon, tone: "blue", group: "finanse" },
  { field: "SingleWindowBox", filterKey: "SingleWindow", label: "Single-Window", Icon: AssuredWorkloadIcon, tone: "blue", group: "finanse" },
  { field: "ObecnoscPracownikaBox", filterKey: "ObecnoscPracownika", label: "Obecność pracownika przy kontroli", Icon: AutoStoriesIcon, tone: "blue", group: "finanse" },
  { field: "COOBox", filterKey: "COO", label: "COO", Icon: BadgeIcon, tone: "blue", group: "finanse" },
  { field: "WysylkaDokumentowBox", filterKey: "WysylkaDokumentow", label: "Wysyłka dokumentów", Icon: BlindsClosedIcon, tone: "blue", group: "finanse" },
  { field: "T2LBox", filterKey: "T2L", label: "T2L", Icon: AddToPhotosIcon, tone: "blue", group: "finanse" },
  { field: "SanepidBox", filterKey: "Sanepid", label: "Sanepid", Icon: SpaIcon, tone: "blue", group: "finanse" },
  { field: "wiecejNiz3Box", filterKey: "wiecejNiz3", label: "Więcej niż 3 pozycje na fakturze wpisane ręcznie", Icon: Filter3Icon, tone: "blue", group: "finanse" },
  { field: "odprawaPo16Box", filterKey: "odprawaPo16", label: "Odprawa zlecona po godzinach", Icon: AccessTimeIcon, tone: "blue", group: "finanse" },
  { field: "zglosBladBox", filterKey: "zglosBlad", label: "Błąd w przygotowanej odprawie", Icon: GppBadIcon, tone: "blue", group: "uwagi" },
  { field: "pilneBox", label: "Pilna odprawa", Icon: WarningIcon, tone: "red" },
  { field: "oczekiwanieNaPlatnoscBox", filterKey: "oczekiwanieNaPlatnosc", label: "Oczekiwanie na płatność", Icon: AccessAlarmIcon, tone: "default", group: "braki" },
  { field: "ponownyMailOBrakiBox", filterKey: "ponownyMailOBraki", label: "Ponowny mail o braki", Icon: GavelIcon, tone: "default", group: "braki" },
  { field: "brakFakturyEdytowalnejBox", filterKey: "brakFakturyEdytowalnej", label: "Faktura edytowalna", Icon: SummarizeIcon, tone: "default", group: "braki" },
  { field: "brakPackingListEdytowalnegoBox", filterKey: "brakPackingListEdytowalnego", label: "Packing list edytowalny", Icon: FormatListNumberedIcon, tone: "default", group: "braki" },
  { field: "brakIncotermsBox", filterKey: "brakIncoterms", label: "INCOTERMS + miejscowość", Icon: ReceiptLongIcon, tone: "default", group: "braki" },
];

export const getMarkerColor = (tone) => TONE_COLORS[tone] || TONE_COLORS.default;

export const isMarkerActive = (marker, row) =>
  marker.when ? marker.when(row) : row[marker.field] === 1;

// Znaczniki filtrowalne w danej grupie, alfabetycznie (łatwiej znaleźć w panelu filtrów).
export const getFilterableMarkers = (groupId) =>
  MARKERS.filter((m) => m.filterKey && m.group === groupId).sort((a, b) =>
    a.label.localeCompare(b.label, "pl", { sensitivity: "base" }),
  );

export const FINANCE_MARKER_KEYS = MARKERS.filter(
  (m) => m.group === "finanse",
).map((m) => m.filterKey);

// ---------------------------------------------------------------------------
// Kolumny tabeli
// ---------------------------------------------------------------------------

// sortKey - klucz akceptowany przez backend (SORT_COLUMNS). Brak = kolumna niesortowalna.
// hiddenByDefault - kolumny, które użytkownik może włączyć w menu "Kolumny".
export const COLUMNS = [
  { id: "transport", label: "Transport", width: 190, sortKey: null },
  { id: "znaczniki", label: "Znaczniki", width: 230, sortKey: null },
  { id: "statusRealizacji", label: "Status", width: 170, sortKey: "statusRealizacji" },
  { id: "importer", label: "Importer", width: 180, sortKey: "importer" },
  { id: "eksporter", label: "Eksporter", width: 180, sortKey: "eksporter" },
  { id: "rodzaj", label: "Rodzaj", width: 150, sortKey: "rodzaj" },
  { id: "osobaPrzygotowujacaOdprawe", label: "Os. przygotowująca", width: 160, sortKey: "osobaPrzygotowujacaOdprawe" },
  { id: "osobaWeryfikujacaOdprawe", label: "Os. weryfikująca", width: 160, sortKey: "osobaWeryfikujacaOdprawe" },
  { id: "osobaWysylajacaOdprawe", label: "Os. wysyłająca", width: 160, sortKey: "osobaWysylajacaOdprawe" },
  { id: "osobaMonitorujacaOdprawe", label: "Os. monitorująca", width: 160, sortKey: "osobaMonitorujacaOdprawe", hiddenByDefault: true },
  { id: "SAD", label: "SAD", width: 130, sortKey: "SAD" },
  { id: "nrAuta", label: "Nr auta", width: 130, sortKey: "nrAuta" },
  { id: "lokalizacjaTowaru", label: "Lok. towaru", width: 150, sortKey: "lokalizacjaTowaru" },
  { id: "adresatDokumentow", label: "Adresat dokumentów", width: 170, sortKey: "adresatDokumentow", hiddenByDefault: true },
  { id: "dokPrzedPrzybyciem", label: "Dokumenty", width: 110, sortKey: null, hiddenByDefault: true },
  { id: "dataT1", label: "Wygaśnięcie T1", width: 130, sortKey: "dataT1" },
  { id: "utworzono", label: "Utworzono", width: 150, sortKey: "utworzono" },
  { id: "endDate", label: "Zakończono", width: 150, sortKey: "endDate" },
  { id: "ileWSystemie", label: "Ile w systemie", width: 130, sortKey: null },
];

export const DEFAULT_HIDDEN_COLUMNS = COLUMNS.filter(
  (c) => c.hiddenByDefault,
).map((c) => c.id);

// ---------------------------------------------------------------------------
// Filtry
// ---------------------------------------------------------------------------

// Kształt zgodny z POST /dashboard/odprawy (Transport-Back/dashboardQuery.js).
export const EMPTY_FILTERS = {
  search: "",
  nrRef: "",
  nrFaktury: "",
  importer: "",
  eksporter: "",
  nrAuta: "",
  mrn: "",
  sad: "",
  adresatDokumentow: "",
  dataTekst: "",
  statusy: [],
  rodzaje: [],
  rodzajeTransportu: [],
  lokalizacje: [],
  dokumenty: [],
  osobaPrzygotowujaca: [],
  osobaWysylajaca: [],
  osobaMonitorujaca: [],
  osobaWeryfikujaca: [],
  utworzonoOd: "",
  utworzonoDo: "",
  zakonczonoOd: "",
  zakonczonoDo: "",
  t1Od: "",
  t1Do: "",
  znaczniki: [],
  rewizja: false,
};

const sameSet = (a = [], b = []) =>
  a.length === b.length && a.every((v) => b.includes(v));

// Szybkie widoki (dawne przyciski "Pokaż moje aktualne odprawy" itd.).
// patch(username) -> fragment filtrów; isActive sprawdza, czy aktualne filtry go zawierają.
const PEOPLE_KEYS = [
  "osobaPrzygotowujaca",
  "osobaWysylajaca",
  "osobaMonitorujaca",
  "osobaWeryfikujaca",
];

// peopleOnly - widoki archiwalne: preset "Moje" zawęża tylko po osobach (statusy/transport
// są tam i tak z góry ograniczone przez widok), a presetów roboczych (SAD, nieprzypisane) brak.
const makePresets = ({ myStatuses, myTransports, peopleOnly = false }) => [
  {
    id: "moje",
    label: "Moje odprawy",
    hint: "Odprawy, w których jesteś osobą przygotowującą, wysyłającą, monitorującą lub weryfikującą",
    patch: (username) => ({
      osobaPrzygotowujaca: [username],
      osobaWysylajaca: [username],
      osobaMonitorujaca: [username],
      osobaWeryfikujaca: [username],
      ...(peopleOnly
        ? {}
        : { statusy: myStatuses, rodzajeTransportu: myTransports }),
    }),
    isActive: (f, username) =>
      PEOPLE_KEYS.every((key) => sameSet(f[key], [username])) &&
      (peopleOnly ||
        (sameSet(f.statusy, myStatuses) &&
          sameSet(f.rodzajeTransportu, myTransports))),
    reset: peopleOnly
      ? PEOPLE_KEYS
      : [...PEOPLE_KEYS, "statusy", "rodzajeTransportu"],
  },
  ...(peopleOnly ? [] : [
  {
    id: "bezSad",
    label: "Bez numeru SAD",
    hint: "Kurier / Na kołach / W drodze bez wpisanego SAD",
    patch: () => ({
      rodzajeTransportu: ["Kurier", "Na Kołach", "W drodze"],
      sad: "empty",
    }),
    isActive: (f) =>
      f.sad === "empty" &&
      sameSet(f.rodzajeTransportu, ["Kurier", "Na Kołach", "W drodze"]),
    reset: ["rodzajeTransportu", "sad"],
  },
  {
    id: "nieprzypisane",
    label: "Nieprzypisane",
    hint: "Odprawy bez osoby przygotowującej",
    patch: () => ({ osobaPrzygotowujaca: ["", null] }),
    isActive: (f) =>
      (f.osobaPrzygotowujaca || []).length === 2 &&
      f.osobaPrzygotowujaca.includes("") &&
      f.osobaPrzygotowujaca.includes(null),
    reset: ["osobaPrzygotowujaca"],
  },
  ]),
];

export const PRESETS = makePresets({
  myStatuses: MY_STATUSES,
  myTransports: MY_TRANSPORTS,
});

const fmtDay = (value) => moment(value, "YYYY-MM-DD").format("DD.MM.YYYY");

const rangeLabel = (name, from, to) => {
  if (from && to) return `${name}: ${fmtDay(from)} – ${fmtDay(to)}`;
  if (from) return `${name}: od ${fmtDay(from)}`;
  return `${name}: do ${fmtDay(to)}`;
};

const listLabel = (name, values) => {
  const shown = values.map((v) => (v === "" || v === null ? "brak" : v));
  return shown.length <= 2
    ? `${name}: ${shown.join(", ")}`
    : `${name}: ${shown.slice(0, 2).join(", ")} +${shown.length - 2}`;
};

/**
 * Zamienia obiekt filtrów na listę chipów do wyświetlenia nad tabelą.
 * Każdy wpis ma `clear` - fragment filtrów, który po scaleniu go usuwa.
 */
export const describeFilters = (f) => {
  const chips = [];
  const text = (key, label) => {
    if (f[key]) {
      const oneLine = String(f[key]).replace(/\s*\n\s*/g, ", ");
      chips.push({ id: key, label: `${label}: ${oneLine}`, clear: { [key]: "" } });
    }
  };
  const list = (key, label) => {
    if (f[key] && f[key].length > 0) {
      chips.push({ id: key, label: listLabel(label, f[key]), clear: { [key]: [] } });
    }
  };
  const range = (fromKey, toKey, label) => {
    if (f[fromKey] || f[toKey]) {
      chips.push({
        id: fromKey,
        label: rangeLabel(label, f[fromKey], f[toKey]),
        clear: { [fromKey]: "", [toKey]: "" },
      });
    }
  };

  text("search", "Szukaj");
  text("nrRef", "Nr ref");
  text("nrFaktury", "Faktura");
  text("importer", "Importer");
  text("eksporter", "Eksporter");
  text("nrAuta", "Nr auta");
  text("mrn", "MRN");
  if (f.sad === "empty") {
    chips.push({ id: "sad", label: "SAD: brak", clear: { sad: "" } });
  } else {
    text("sad", "SAD");
  }
  text("adresatDokumentow", "Adresat");
  text("dataTekst", "Data");
  list("statusy", "Status");
  list("rodzaje", "Rodzaj");
  list("rodzajeTransportu", "Transport");
  list("lokalizacje", "Lokalizacja");
  list("dokumenty", "Dokumenty");
  list("osobaPrzygotowujaca", "Przygotowuje");
  list("osobaWysylajaca", "Wysyła");
  list("osobaMonitorujaca", "Monitoruje");
  list("osobaWeryfikujaca", "Weryfikuje");
  range("utworzonoOd", "utworzonoDo", "Utworzono");
  range("zakonczonoOd", "zakonczonoDo", "Zakończono");
  range("t1Od", "t1Do", "Wygaśnięcie T1");
  if (f.znaczniki && f.znaczniki.length > 0) {
    const labels = f.znaczniki.map(
      (key) => MARKERS.find((m) => m.filterKey === key)?.label || key,
    );
    chips.push({
      id: "znaczniki",
      label:
        labels.length <= 2
          ? `Znaczniki: ${labels.join(", ")}`
          : `Znaczniki: ${labels.slice(0, 2).join(", ")} +${labels.length - 2}`,
      clear: { znaczniki: [] },
    });
  }
  if (f.rewizja) {
    chips.push({ id: "rewizja", label: "Rewizja", clear: { rewizja: false } });
  }
  return chips;
};

// Liczba aktywnych filtrów bez pola szybkiego wyszukiwania (do plakietki przy przycisku "Filtry").
export const countActiveFilters = (f) =>
  describeFilters({ ...f, search: "" }).length;

// ---------------------------------------------------------------------------
// Inne
// ---------------------------------------------------------------------------

export const PAGE_SIZE_OPTIONS = [20, 50, 100, 200];

export const STORAGE_KEY = "dashboardView.v2";

// ---------------------------------------------------------------------------
// Widoki (ten sam komponent tabeli, różne zestawy danych - patrz VIEWS w dashboardQuery.js)
// ---------------------------------------------------------------------------

const ENDED_STATUSES = ["Zrealizowane", "Unieważnione przez OC", "Anulowane"];

const TRANSIT_ACTIVE_STATUSES = [
  "Do przygotowania",
  "Wstępnie przygotowane",
  "Przygotowane",
  "Do weryfikacji",
  "Do poprawy",
  "Do wysłania",
  "Wysłane",
  "Przyjęte przez Gwaranta",
  "Wysłano do urzędu",
  "Zwolniono do tranzytu",
];

// Tranzyt: "Lok. towaru" to w praktyce urząd celny wyjścia.
const transitColumns = COLUMNS.map((c) =>
  c.id === "lokalizacjaTowaru"
    ? { ...c, label: "Urząd celny wyjścia", width: 170 }
    : c,
);

const TRANSIT_MY_STATUSES = [
  "Do przygotowania",
  "Wstępnie przygotowane",
  "Wysłane",
  "Do wysłania",
  "Do weryfikacji",
];

/**
 * Opis każdego widoku:
 *  - storageKey: klucz w localStorage (odprawy zachowują dotychczasowy, żeby nikt nie stracił ustawień)
 *  - detailFrom: wartość `state.from` dla strony szczegółów (DetailPage wraca tam przyciskiem "Wstecz")
 */
export const VIEW_CONFIG = {
  odprawy: {
    title: "Odprawy",
    path: "/user",
    storageKey: STORAGE_KEY,
    detailFrom: "dashboard",
    columns: COLUMNS,
    statusOptions: STATUS_OPTIONS,
    presets: PRESETS,
    locationLabel: "Lokalizacja towaru",
    countLabel: "aktywnych odpraw",
    filteredLabel: "odpraw spełnia filtry",
    emptyTitle: "Brak odpraw do wyświetlenia",
    emptyText: "W systemie nie ma aktywnych odpraw.",
    searchPlaceholder: "Szukaj po nr ref, importerze, MRN, osobie…",
    unitLabel: "odpraw",
  },
  archiwum: {
    title: "Archiwum odpraw",
    path: "/archive",
    storageKey: "dashboardView.v2.archiwum",
    detailFrom: "archive",
    columns: COLUMNS,
    statusOptions: ENDED_STATUSES,
    presets: makePresets({ peopleOnly: true }),
    locationLabel: "Lokalizacja towaru",
    countLabel: "zakończonych odpraw",
    filteredLabel: "odpraw spełnia filtry",
    emptyTitle: "Brak odpraw w archiwum",
    emptyText: "W archiwum nie ma jeszcze zakończonych odpraw.",
    searchPlaceholder: "Szukaj w archiwum po nr ref, importerze, MRN, osobie…",
    unitLabel: "odpraw",
  },
  tranzyt: {
    title: "Odprawy Tranzyt",
    path: "/tranzyt",
    storageKey: "dashboardView.v2.tranzyt",
    detailFrom: "tranzyt",
    columns: transitColumns,
    statusOptions: TRANSIT_ACTIVE_STATUSES,
    presets: makePresets({
      myStatuses: TRANSIT_MY_STATUSES,
      myTransports: MY_TRANSPORTS,
    }),
    locationLabel: "Urząd celny wyjścia",
    countLabel: "aktywnych odpraw tranzytowych",
    filteredLabel: "odpraw tranzytowych spełnia filtry",
    emptyTitle: "Brak odpraw tranzytowych do wyświetlenia",
    emptyText: "W systemie nie ma aktywnych odpraw tranzytowych.",
    searchPlaceholder: "Szukaj po nr ref, importerze, MRN, osobie…",
    unitLabel: "odpraw tranzytowych",
  },
  tranzytArchiwum: {
    title: "Archiwum tranzyt",
    path: "/archiveTranzyt",
    storageKey: "dashboardView.v2.tranzytArchiwum",
    detailFrom: "tranzytArchive",
    columns: transitColumns,
    statusOptions: ["Tranzyt zakończony", ...ENDED_STATUSES],
    presets: makePresets({ peopleOnly: true }),
    locationLabel: "Urząd celny wyjścia",
    countLabel: "zakończonych odpraw tranzytowych",
    filteredLabel: "odpraw tranzytowych spełnia filtry",
    emptyTitle: "Brak odpraw tranzytowych w archiwum",
    emptyText: "W archiwum nie ma jeszcze zakończonych odpraw tranzytowych.",
    searchPlaceholder: "Szukaj w archiwum tranzytu po nr ref, importerze, MRN, osobie…",
    unitLabel: "odpraw tranzytowych",
  },
};

export const getViewConfig = (view) => VIEW_CONFIG[view] || VIEW_CONFIG.odprawy;

// Domyślnie widoczne są wszystkie kolumny (także po "Przywróć domyślne").
export const getDefaultHiddenColumns = () => [];
